import axios from "axios";

// Same-origin in production; CRA proxy forwards to :5000 in dev.
const api = axios.create({ withCredentials: true });

function messageFrom(err, fallback) {
    return (err && err.response && err.response.data && err.response.data.message) || fallback;
}

export const authApi = {
    me: () => api.get("/api/user"),
    stats: () => api.get("/api/user/stats"),
    login: (username, password) => api.post("/api/users/auth", { username, password }),
    logout: () => api.post("/api/users/logout"),
    generateApiKey: () => api.post("/api/user/api-key"),
    revokeApiKey: () => api.delete("/api/user/api-key"),
};

export const paymentsApi = {
    checkout: (packageId, language) => api.post("/api/payments/checkout", { package_id: packageId, language }),
    verify: (externalOrderId) => api.post("/api/payments/verify", { external_order_id: externalOrderId }),
    orders: () => api.get("/api/payments/orders"),
};

export const reportApi = {
    getByVin: (vin) => api.get(`/api/report/carfax?vin=${encodeURIComponent(vin)}`),
    cleanVin: (vin) => api.delete(`/api/records/remove/${encodeURIComponent(vin)}`),
    exportPdf: (vin) => api.get(`/api/report/pdf?vin=${encodeURIComponent(vin)}`, { responseType: "blob" }),
};

export const adminApi = {
    users: () => api.get("/api/admin/users"),
    transactions: (params) => api.get("/api/admin/transactions", { params }),
    earnings: (params) => api.get("/api/admin/earnings", { params }),
    createUser: (payload) => api.post("/api/admin/users", payload),
    deleteUser: (id) => api.delete(`/api/admin/users/${id}`),
    setPassword: (id, password) => api.put(`/api/admin/users/${id}/password`, { password }),
    setActive: (id, active) => api.put(`/api/admin/users/${id}/block`, { active }),
    getToken: () => api.get("/api/admin/token"),
    setToken: (payload) => api.put("/api/admin/token", payload),
};

export const subusersApi = {
    list: () => api.get("/api/subusers"),
    create: (payload) => api.post("/api/subusers", payload),
    setLimit: (id, request_limit) => api.put(`/api/subusers/${id}/limit`, { request_limit }),
    setPassword: (id, password) => api.put(`/api/subusers/${id}/password`, { password }),
    setActive: (id, active) => api.put(`/api/subusers/${id}/block`, { active }),
    remove: (id) => api.delete(`/api/subusers/${id}`),
};

export const packagesApi = {
    list: () => api.get("/api/packages"),
};

export { messageFrom };
export default api;
